export function handleHasAccountInputs(): void {
  const $hasAccountInputs = document.querySelectorAll<HTMLInputElement>('input[name="has-account"]')

  if ($hasAccountInputs) {
    const $hasAccount = document.querySelector<HTMLDivElement>('#has-account-container')
    const $hasNotAccount = document.querySelector<HTMLDivElement>('#has-not-account-container')

    $hasAccountInputs.forEach((input: HTMLInputElement) => {
      input.addEventListener('click', () => {
        if (input.checked) {
          const dataAccount = input.getAttribute('data-account')

          if (dataAccount === 'has-account') {
            $hasAccount.hidden = false
            $hasNotAccount.hidden = true
          } else {
            $hasAccount.hidden = true
            $hasNotAccount.hidden = false
          }
        }
      })
    })
  }
}
